import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { compose, withApollo } from 'react-apollo'
import { withRouter } from 'react-router'
import { Form, Modal, Tabs } from 'antd'

import LoginForm from './LoginForm'
import RegisterForm from './RegisterForm'

import { logoutUser, getAuthUri } from '../../auth'

// const FormItem = Form.Item

// const currentUser = gql`
//   query currentUser {
//     currentUser {
//       _id
//       email
//       profile {
//         firstName
//         lastName
//       }
//     }
//   }
// `

class AuthModal extends Component {
  static propTypes = {
    visible: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    redirectTo: PropTypes.string
  }

  handleLogout = () => {
    logoutUser().then(() => {
      this.props.client.resetStore()
      this.props.history.push('/')
    })
  }
  render () {
    // const { getFieldDecorator } = this.props.form
    return (
      <Modal
        title={null}
        style={{ top: 10 }}
        visible={this.props.visible}
        onOk={this.handleOk}
        onCancel={this.props.onClose}
        cancelText="Cancel"
        okText="Login"
        footer={null}
      >
        <div className="loginModalHeader">
          <img src="/thairun-logo.png" alt="" />
        </div>
        <Tabs>
          <Tabs.TabPane tab="Login" key="login">
            <div className="facebookBox">
              <a href={getAuthUri('facebook', { redirectTo: this.props.redirectTo })}>
                <span className="facebookText">
                  Login with Facebook
                </span>
              </a>
            </div>
            <LoginForm onClose={this.props.onClose} />
          </Tabs.TabPane>
          <Tabs.TabPane tab="Register" key="register">
            <div className="facebookBox">
              <span className="facebookText">
                Signup with Facebook
              </span>
            </div>
            <RegisterForm onClose={this.props.onClose} />
          </Tabs.TabPane>
        </Tabs>
      </Modal>
    )
  }
}

export default compose(
  Form.create(),
  withApollo,
  withRouter // TODO: should put router only inside auth wrapper
)(AuthModal)



// WEBPACK FOOTER //
// ./src/common/AuthModal/AuthModal.js